import { Lightning } from '@lightningjs/sdk'
import { getColor, grey200, grey50 } from '../../constants/colors'
import { getText } from '../../utils/dictionary'
import Button from '../button/button'

export class PartialErrorMessage extends Lightning.Component {
  private _retryAction: () => void

  static _template() {
    return {
      w: (w) => w,
      h: (h) => h,
      flex: {
        direction: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      },
      Title: {
        text: {
          text: getText('genericErrorTitle'),
          textColor: getColor(grey50),
          fontSize: 40,
        },
      },
      Subtitle: {
        text: {
          text: getText('genericErrorText'),
          textColor: getColor(grey200),
          fontSize: 32,
        },
      },
      Button: {
        w: 668,
        type: Button,
        label: getText('reload'),
        flexItem: { marginTop: 24 },
      },
    }
  }

  get title() {
    return this.tag('Title')
  }

  get subtitle() {
    return this.tag('Subtitle')
  }

  get button() {
    return this.tag('Button')
  }

  _getFocused() {
    return this.button
  }

  _handleEnter() {
    this?._retryAction()
  }

  toggleError(on: boolean, params?: { isNetworkError: boolean; retryAction: () => void }) {
    this.visible = on

    if (params?.isNetworkError) {
      this.title.patch({ text: { text: getText('connectionErrorTittle') } })
      this.subtitle.patch({ text: { text: getText('connectionErrorSubtitle') } })
    } else {
      this.title.patch({ text: { text: getText('genericErrorTitle') } })
      this.subtitle.patch({ text: { text: getText('genericErrorText') } })
    }

    if (params?.retryAction) {
      this._retryAction = params.retryAction
    }
  }
}
